import { StarItem } from './styles';

export default function Star() {
  return <StarItem />;
}
